export function ofuscate(data: any): string {
  try {
    const ofuscatedData = btoa(JSON.stringify(data));
    return ofuscatedData.split('=').join('');
  }
  catch (e) {
    return '';
  }
}

export function deofuscate(data: string): any {
  try {
    let deofuscatedData = 0;

    for (let i = 0; i < 10; i++) {
      try {
        const recreatedB = data + (new Array(i)).fill('=').join('');
        deofuscatedData = JSON.parse(atob(recreatedB));
        break;
      }
      catch (e) { }
    }
    return deofuscatedData;
  }
  catch (e) {
    return 0;
  }
}
